import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { GuidesListPage } from './pages/GuidesListPage';
import { GuideDetailPage } from './pages/GuideDetailPage';
import { CategoryPage } from './pages/CategoryPage';
import { MethodologyPage } from './pages/MethodologyPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="guides" element={<GuidesListPage data-id="element-7" />} data-id="element-6" />
          <Route path="guide/:slug" element={<GuideDetailPage data-id="element-9" />} data-id="element-8" />
          <Route path="category/:slug" element={<CategoryPage data-id="element-11" />} data-id="element-10" />
          <Route path="methodology" element={<MethodologyPage data-id="element-13" />} data-id="element-12" />
          <Route path="about" element={<AboutPage data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </HashRouter>;
}